/** @format */

import axios from 'axios'

import { notification } from 'antd'

import { Loading } from '../../../components/Loading'
import { Response } from '../../../components/Response'

import { ENV_FUNCTION_PUNTO_PAGO } from '../../../hooks/enviroment'

export async function serviceInjectToken(item) {
	Loading.open()
	return await axios({
		method: 'GET',
		url: `${ENV_FUNCTION_PUNTO_PAGO}/inject-token/${item.token}/${item.module}`,
	})
		.then(async (response) => {
			Loading.close()
			Response.open(response.data, 'Token')
			return response.data
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${ENV_FUNCTION_PUNTO_PAGO}/inject-token/${item.token}/${item.module}`,
			})
			return error.response.data
		})
}
